import {
  TeamExternalIntegration,
  ResponseBodyEvaluation,
  Predicate
} from 'types/api/services/golden-signal'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

export const appdynamicsStatusCheckIntegration: TeamExternalIntegration = {
  name: 'AppDynamics',
  type: IntegrationType.Appdynamics,
  authUrl: '',
  isPrivateNetworkIntegration: false,
  headers: [{ key: 'Authorization', value: '', label: 'API Key' }],
  url: '',
  sortIndex: 5
}

export const appdynamicsBaseUrlRegex = new RegExp(
  '^https:\\/\\/(.+)\\.saas\\.appdynamics\\.com\\/?$'
)

export const appdynamicsApplicationUrlRegex = new RegExp(
  '^https:\\/\\/(.+)\\.saas\\.appdynamics\\.com\\/controller\\/#\\/(.*)application=([0-9]+)'
)

const durationInMins = 15
export const appdynamicsApiHealthRuleViolationsUrlRegex = new RegExp(
  `^https:\\/\\/(.+)\\.saas\\.appdynamics\\.com\\/controller\\/rest\\/applications\\/([0-9]+)\\/problems\\/healthrule-violations\\?time-range-type=BEFORE_NOW&duration-in-mins=${durationInMins}&output=JSON`
)

export function convertToAppDynamicsUrl(url: string): string {
  if (appdynamicsApplicationUrlRegex.test(url)) {
    const domainName = appdynamicsApplicationUrlRegex.exec(url)?.[1]
    const applicationId = appdynamicsApplicationUrlRegex.exec(url)?.[3]
    return `https://${domainName}.saas.appdynamics.com/controller/rest/applications/${applicationId}/problems/healthrule-violations?time-range-type=BEFORE_NOW&duration-in-mins=${durationInMins}&output=JSON`
  }

  if (appdynamicsApiHealthRuleViolationsUrlRegex.test(url)) {
    return url
  }

  if (appdynamicsBaseUrlRegex.test(url)) {
    const domainName = appdynamicsBaseUrlRegex.exec(url)?.[1]
    return `https://${domainName}.saas.appdynamics.com/controller/rest/applications/`
  }

  return null
}

export function convertToAppDynamicsBaseUrl(url: string): string {
  const regexes = [
    appdynamicsBaseUrlRegex,
    appdynamicsApplicationUrlRegex,
    appdynamicsApiHealthRuleViolationsUrlRegex
  ]

  const matchedRegexes = regexes.filter((regex) => regex.test(url))

  if (matchedRegexes.length === 0) {
    return ''
  }

  return `https://${matchedRegexes[0].exec(url)?.[1]}.saas.appdynamics.com/`
}

export const appdynamicsResponseBodyEvaluationConfiguration: ResponseBodyEvaluation =
  {
    op: 'AND',
    predicates: [
      {
        type: 'Number',
        jpQuery: '.length()',
        rValue: 0,
        comparator: 'EQU'
      } as Predicate
    ]
  }
